import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import AuthService from '../../controllers/AuthService';
import ClassesSummary from './Parts/Overview/ClassesSummary';
import TopStrengthSummary from './Parts/Overview/TopStrengthSummary';
import HomeroomSummary from './Parts/Overview/HomeroomSummary';
import UserService from '../../controllers/UserService';
import RiasecReportSummary from '../riasec/ReportSummary';

const Overview = props => {

    const [yearTermSelection, setYearTermSelection] = useState(null);
    const [filterYear, setFilterYear] = useState(null);
    const [filterTerm, setFilterTerm] = useState(null);

    useEffect(() => {
        UserService.distinctYearTerm().then((response) => {
            const yearTerm = response?.data?.data.reverse();

            let ytText
            let yTS = []
            for (const [key, value] of Object.entries(yearTerm)) {
                if (parseInt(key) === 0) {
                    setFilterYear(yearTerm[key].year)
                    setFilterTerm(yearTerm[key].term)
                }
                ytText = yearTerm[key].term + '/' + yearTerm[key].year;
                yTS.push({
                    value: ytText,
                    text: ytText,
                })
            };
            setYearTermSelection(yTS)
        });

    }, [])

    const dropdownClassesCompute = (e) => {
        const selectedVal = e.target.value
        const filters = selectedVal.split('/')
        setFilterYear(filters[1])
        setFilterTerm(filters[0])
    }

    return (
        <>
            <Row className='overview-page mt-2 mb-5'>
                <Col xs={12}><h1 className='text-center page-headline'>Dashboard <span class="doNotWrap">ภาพรวมของโรงเรียน</span></h1></Col>
                <Col xs={4} lg={4} className='termyear-text font-sarabun-bold d-flex mt-3'>
                    <div className='d-inline new-headmaster-label-dropdown'>ภาคการศึกษา</div>
                    <div className='d-inline ml-3'>
                        <select class="form-control form-control-sm border-radius-5 font-sarabun main-dropdown" onChange={dropdownClassesCompute}>
                            {
                                (yearTermSelection && yearTermSelection.length > 0) ? (
                                    yearTermSelection.map((item, index) => (
                                        <option value={item.value} key={index}>{item.text}</option>
                                    ))
                                ) : (
                                    null
                                )
                            }
                        </select></div>
                </Col>
                <Col xs={12} lg={8} className='text-center text-lg-right mt-3'>
                    <div className='headmaster-name pt-3 pt-lg-0'>ผู้อำนวยการ : {AuthService.getUserFullName()}</div>
                </Col>
                <Col xs={12}>
                    {(filterYear && filterTerm) ? <TopStrengthSummary filterYear={filterYear} filterTerm={filterTerm} /> : null}
                </Col>
                <Col xs={12}>
                    {(filterYear && filterTerm) ? <RiasecReportSummary filterYear={filterYear} filterTerm={filterTerm} showFor="domain" customTitle="ผลประเมินแบบทดสอบความสนใจทางอาชีพ" customSubtitle="จากการทำประเมินแล้ว" customBorder={true} mobileShowHide={false} /> : null}
                </Col>
                <Col xs={12}>
                    {(filterYear && filterTerm) ? <HomeroomSummary filterYear={filterYear} filterTerm={filterTerm} /> : null}
                </Col>
                <Col xs={12}>
                    {(filterYear && filterTerm) ? <ClassesSummary filterYear={filterYear} filterTerm={filterTerm} /> : null}
                </Col>
            </Row>
        </>
    )



}

export default Overview